import React, { useState, useEffect } from "react";
import axios from "axios";
import logo from "../assets/logo1.webp";
import "./Home.css";

export default function Home() {
  const [contractAddress, setContractAddress] = useState("Fetching...");
  const [copy, setCopy] = useState("bi bi-clipboard-plus");

  useEffect(() => {
    const fetchContractAddress = async () => {
      try {
        // Correctly format the GET request
        const query = encodeURIComponent(`*[_type=='sanityObject']{address}`);
        const url = `https://zd5gpcqi.api.sanity.io/v2023-01-01/data/query/production?query=${query}`;
        
        // Properly include headers
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer skkCHkrkoWdJ29som8TguUut49Hs8awzQXEd9yNuyc937Fbydx00BqDSnZvpBV8hq8P5vzIVyTWggpDfgyuXh1jt0wweCKPIqdYkweQPyIpNYdW06s6IXZhvvr7fza8fKwCxFHVjFmiJRrz91NEc5HTUYwzAt82zd2mM0xJAkrLbNOl6w90p`, // Use Bearer before the token
          },
        });
  
        // Safely extract the address
        const address = response.data.result?.[0]?.address || "Unlaunched yet";
        setContractAddress(address);
  
      } catch (error) {
        console.error("Error fetching contract address:", error);
        setContractAddress("Unlaunched yet");
      }
    };
  
    fetchContractAddress();
  }, []);
  

  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Clipboard API supported
      navigator.clipboard
        .writeText(contractAddress)
        .then(() => setCopy("bi bi-clipboard-check"))
        .catch(() => setCopy("bi bi-clipboard-plus"));
    } else {
      // Fallback for unsupported browsers
      const tempInput = document.createElement("textarea");
      tempInput.value = contractAddress;
      document.body.appendChild(tempInput);
      tempInput.select();
      try {
        document.execCommand("copy");
        setCopy("bi bi-clipboard-check");
      } catch (err) {
        console.error("Fallback: Copy failed", err);
        setCopy("bi bi-clipboard-plus");
      }
      document.body.removeChild(tempInput);
    }
  };

  return (
    <div className="home-container">
      {/* Contract Address */}
      <div className="contract-address">
        <p>
          CA: {contractAddress}
          {contractAddress !== "Fetching..." && contractAddress !== "Unlaunched yet" && (
            <i
              className={copy}
              onClick={handleCopy}
              style={{ color: "black", cursor: "pointer" }}
            ></i>
          )}
        </p>
      </div>

      {/* Logo */}
      <img src={logo} alt="Website Logo" className="logo" />

      {/* Main Content */}
      <h1 className="title2">Welcome to Cinnamoroll: Your Gateway to a Sweet Future</h1>
      <p className="description" style={{ fontFamily: "Poppins-light" }}>
        It’s all about bringing sweetness and joy to everyone. Simple, fun, and made with love—join the adventure today!
      </p>

      {/* Button */}
      <a href="https://t.me/" target="_blank" rel="noopener noreferrer">
        <button className="join-button">Join the telegram now</button>
      </a>
    </div>
  );
}
